export default __webpack_public_path__ + "static/media/04_prompts.9322d25b.png";